// Helpers visuels partagés entre la vue Arbre (FamilyTree) et les renderers
// d'export (components/charts/*). Extraits de FamilyTree.tsx pour éviter la
// duplication : couleurs par génération + formatage de dates.

// Couleurs par génération (profondeur dans l'arbre)
export const GEN_COLORS = ['#8B5CF6', '#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#EC4899', '#6366F1'];
export const genColor = (depth: number): string => GEN_COLORS[depth % GEN_COLORS.length];

// Date complète "22 mars 1952" (ou null si absente)
export const fullDate = (d?: string): string | null => {
  if (!d) return null;
  return new Date(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
};

// Date compacte "12.06.1980" pour les libellés de couple (ou null si absente)
export const shortDate = (d?: string): string | null => {
  if (!d) return null;
  return new Date(d).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

// Plage d'années "1902 – 1980" (ou "1902" si vivant, "" si aucune date)
export const yearsRange = (naissance?: string, deces?: string): string => {
  if (!naissance && !deces) return '';
  const b = naissance ? new Date(naissance).getFullYear() : '?';
  return deces ? `${b} – ${new Date(deces).getFullYear()}` : `${b}`;
};
